import { anyDisablingProcess } from "../reducers/disablingProcesses";
import { getRandomModeActive } from "../reducers/randomMode";
import { setClearQueueForPlayAlbum } from "./clearQueueActions";
import { setAlbumItemContextMenu } from "./contextMenuActions";

export const clickAlbumItem = (album, clickEvent) => {
    return (dispatch, getState) => {
        const state = getState();
        const disabled = anyDisablingProcess(state);

        if(disabled)
        {
            return;
        }
        
        const randomModeActive = getRandomModeActive(state);

        if(!randomModeActive && clickEvent.type === 'click')
        {
            dispatch(setClearQueueForPlayAlbum(album));
        }
        else
        {
            dispatch(setAlbumItemContextMenu(album, clickEvent));
        }
    }
}